<template>
  <v-autocomplete
    :value="value"
    class="input-field"
    @input="$emit('input', $event)"
    @change="itemChange"
    :disabled="disabled"
    :search-input.sync="searchString"
    :items="availableParticipants"
    outlined
    chips
    small-chips
    background-color="#F3F3F3"
    label="Select Recipients"
    item-text="name"
    return-object
    multiple
    dense
    hide-selected
    single-line
    :rules="[rules.selectionRequired]"
  >
    <template v-slot:selection="{ item, attrs, selected, select, index }">
      <v-chip
        class="ma-1"
        v-if="index < 7"
        v-bind="attrs"
        :input-value="selected"
        close
        @click="select"
        @click:close="remove(item)"
        small
        color="primary"
      >
        {{ item.name }}
      </v-chip>
      <span v-if="index === 7" class="grey--text caption">
        (+{{ value.length - 7 }} others)
      </span>
    </template>
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-item-content v-text="data.item"></v-list-item-content>
      </template>
      <template v-else>
        <Avatar
          class="ma-2"
          :size="36"
          :id="data.item.id"
          :user="data.item"
          borderColor="transparent"
        />
        <v-list-item-content>
          <v-list-item-title>
            {{ getSelectionPrefix(data.item.type) }} [{{ data.item.type }}]
            {{ data.item.name }}
          </v-list-item-title>
          <v-list-item-subtitle
            style="max-width: 300px; text-overflow: ellipsis"
          >
            {{ getUserString(data.item.users) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-icon color="primary">mdi-plus-circle</v-icon>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>
import Vue from "vue";
import { getAvailableParticipants } from "@/helpers/api";
import Avatar from "@/components/Avatar.vue";
import rules from "@/helpers/FieldValidationRules";

export default Vue.extend({
  name: "AvailableDMParticipantsSearch",
  components: { Avatar },
  props: {
    disabled: { type: Boolean, required: true },
    value: { type: Array, required: true },
    selectedOrganization: { type: String, required: false },
    targetUsers: { type: Array, required: false }
  },
  data() {
    return {
      availableParticipants: [],
      searchString: "",
      rules: rules
      // searchResult: null
    };
  },
  mounted() {
    if (this.selectedOrganization) {
      this.getAvailableParticipants(this.selectedOrganization);
    }
  },
  methods: {
    itemChange(e) {
      this.selected = e;
      this.$nextTick(() => {
        this.searchString = "";
      });
    },
    remove(e) {
      this.$emit(
        "input",
        this.value.filter(p => p.name !== e.name)
      );
    },
    selectTargetUsers(users) {
      const list = this.availableParticipants.filter(p =>
        users.find(u => u.id === p.id || u === p.id)
      );
      this.$emit("input", list);
    },
    async getAvailableParticipants(orgId) {
      this.availableParticipants = await getAvailableParticipants(orgId);
      if (this.targetUsers) {
        this.selectTargetUsers(this.targetUsers);
      }
      this.$emit("resetValidation");
    },
    getUserString(users) {
      if (users.length > 4) {
        return this.userStringBuilder(users);
      } else {
        return this.userStringBuilder(users);
      }
    },

    userStringBuilder(arr, size) {
      const arrToReduce = size ? arr.slice(0, size) : arr;
      return arrToReduce.reduce((acc, cur, idx) => {
        return (acc += `${idx > 0 ? ", " : ""}${cur.name}`);
      }, "");
    },

    getSelectionPrefix(type) {
      return type === "EVENT" ? "Event: " : type === "ORG_UNIT" ? "Team: " : "";
    }
  },
  watch: {
    selectedOrganization: function(orgId) {
      // watch it
      this.getAvailableParticipants(orgId);
    },
    targetUsers: function(users) {
      if (users) {
        this.selectTargetUsers(users);
      }
    }
  }
});
</script>
<style scoped>
.input-field {
  box-sizing: border-box;
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
